import { Component, output, input, inject, signal } from '@angular/core';
import { OuiTabsModule } from 'omnium-ui/tabs';
import { OuiButton } from 'omnium-ui/button';
import { OuiIconModule } from 'omnium-ui/icon';
import { OuiCheckbox, OuiTextarea, OuiValidationError } from 'omnium-ui/form-field';
import {
  DOCUMENT_CONSULTANT_AUTOCOMPLETE_OPTIONS,
  DOCUMENT_TYPE_LABELS,
  DocumentCanBeUploadedType,
} from '@lib/models/documents/document-consultant-type';
import { SelectionModel } from '@angular/cdk/collections';
import { DocumentService } from '@lib/services/documents/documents.service';
import { OuiSnackbarService } from 'omnium-ui/snackbar';
import { OuiChipModule } from 'omnium-ui/chip';
import { FormControl, Validators } from '@angular/forms';
import { OuiLoading } from 'omnium-ui/loading';

@Component({
  selector: 'lib-demande-pj-panel',
  standalone: true,
  imports: [
    OuiTabsModule,
    OuiButton,
    OuiIconModule,
    OuiCheckbox,
    OuiChipModule,
    OuiTextarea,
    OuiLoading,
  ],
  templateUrl: './demande-pj-panel.component.html',
  styleUrl: './demande-pj-panel.component.scss',
})
export class DemandePjPanelComponent {
  private readonly documentService = inject(DocumentService);
  private readonly snackbarService = inject(OuiSnackbarService);

  readonly codeConsusltant = input.required<string>();
  readonly consultantName = input.required<string>();
  readonly consultantLastname = input.required<string>();

  readonly close = output();
  readonly setDisplayDemandePjPanel = output();

  readonly isLoading = signal<boolean>(false);
  readonly displayComment = signal<boolean>(true);
  readonly docOptions = DOCUMENT_CONSULTANT_AUTOCOMPLETE_OPTIONS;
  readonly docLabel = DOCUMENT_TYPE_LABELS;
  readonly selection = new SelectionModel<DocumentCanBeUploadedType>(true);
  readonly commentControl = new FormControl<string>(
    `Dans le cadre de notre collaboration, nous aurions besoin de récupérer certains documents de votre part.

Documents attendus :
`,
    [Validators.required]
  );
  readonly commentErrors: OuiValidationError[] = [
    { code: 'required', message: 'Un commentaire est requise' },
  ];

  async onClickSendDemande() {
    if (this.selection.selected.length === 0 && !this.commentControl?.value) {
      return;
    }

    try {
      this.isLoading.set(true);
      await this.documentService.sendDemandePjByEmail(
        this.codeConsusltant(),
        this.selection.selected,
        this.putDocTypeInComment()
      );

      this.isLoading.set(false);
      this.setDisplayDemandePjPanel.emit();
      this.snackbarService.open('La demande de documents a bien été envoyée', 'success');
    } catch (e) {
      console.error(e);
      this.isLoading.set(false);
      this.snackbarService.open(
        "Une erreur est survenue durant l'envoie de la demande",
        'error'
      );
    }
  }

  putDocTypeInComment(): string {
    const parseCommentValue = this.commentControl.value?.replace(/\n/g, '<br>');

    return (
      parseCommentValue +
      this.selection.selected.map(docType => `${this.docLabel[docType]}`).join(', ')
    );
  }

  removeFilter(docType: DocumentCanBeUploadedType) {
    this.selection.setSelection(
      ...this.selection.selected.filter(sel => sel !== docType)
    );
  }

  deleteAllFilters() {
    this.selection.clear();
  }
}
